import { render, staticRenderFns } from "./FilterTaxonomicGroup.vue?vue&type=template&id=336d13d1&"
import script from "./FilterTaxonomicGroup.vue?vue&type=script&lang=js&"
export * from "./FilterTaxonomicGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports